export default function PreviewFooter() {
  return (
    <footer
      style={{
        padding: "24px",
        textAlign: "center",
        color: "#6b7280",
        fontSize: 13
      }}
    >
      Powered by NetShine ONE
    </footer>
  );
}
